import {Component, Input, OnInit} from "@angular/core";
import {Product} from "../../../persistence/circular-dto/product.conflict";

@Component({
  selector: 'kt-small-product-card',
  templateUrl: './small-product-card.component.html',
  styleUrls: ['./small-product-card.component.scss']
})
export class SmallProductCardComponent implements OnInit {

    @Input() product : Product;

    constructor() { }

    ngOnInit() {
        console.log(this.product)
    }

}
